// F-MOTOR-RESERVAS.3.1.4 — Idempotency-Key gerada no cliente.
// Backend aceita o header `Idempotency-Key` OU o campo no payload.
// A mesma chave em dois submits retorna a MESMA reserva (sem duplicar).

import { useRef } from "react";

/** Gera UUID v4 (fallback para ambientes sem crypto.randomUUID). */
export function newIdempotencyKey() {
  try {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
      return crypto.randomUUID();
    }
  } catch (_) { /* noop */ }
  // Fallback RFC-4122 v4
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * Hook que gera UMA key por montagem do fluxo. F5 reseta (nova intenção).
 * Mesmo componente, múltiplos submits → mesma key → backend retorna a mesma reserva.
 */
export function useIdempotencyKey() {
  const ref = useRef(null);
  if (ref.current === null) ref.current = newIdempotencyKey();
  return ref.current;
}
